import { render, staticRenderFns } from "./EditableQuiz.vue?vue&type=template&id=77b4fe2e&scoped=true&"
import script from "./EditableQuiz.vue?vue&type=script&lang=js&"
export * from "./EditableQuiz.vue?vue&type=script&lang=js&"
import style0 from "./EditableQuiz.vue?vue&type=style&index=0&id=77b4fe2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4fe2e",
  null
  
)

export default component.exports